module.exports = __webpack_public_path__ + "img/baby-verified.6d792b0.png";